import React from 'react';
import { useNavigate } from 'react-router-dom';
import ZomatoPayoutCalculator from '../../components/ZomatoPayoutCalculator';

/**
 * Restaurant-facing, self-serve Zomato payout calculator. Lets a restaurant enter
 * its Zomato sales, commission, ad %, convenience fee and discount and see exactly
 * what it receives — plus how much more it would keep on FoodWinc.
 */
function RestaurantZomatoPayout() {
  const navigate = useNavigate();
  return (
    <div style={{ background: '#F8FAFC', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: 24 }}>
        <button
          onClick={() => navigate('/restaurant/dashboard')}
          style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', color: '#334155', marginBottom: 16 }}
        >← Dashboard</button>
        <div style={{ background: 'linear-gradient(135deg, #1f2937 0%, #374151 100%)', borderRadius: 16, padding: 32, marginBottom: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
          <h1 style={{ fontSize: 30, fontWeight: 700, color: '#fff', marginBottom: 8, letterSpacing: '-0.5px' }}>Are you making money on Tomato?</h1>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, margin: 0 }}>
            Enter your sales, markup, discount, commission, ads &amp; convenience fee — see what you actually receive,
            whether you're <b>profiting or selling at a loss</b> after food cost, and how much more you'd keep on FoodWinc.
          </p>
        </div>
        <ZomatoPayoutCalculator />
      </div>
    </div>
  );
}

export default RestaurantZomatoPayout;
